/**
 * Load the right hero image from an img tag.
 * The tag has src set, so it updates the image when src changes.
 */
export function blockHeroHomeBgImage() {
    let mobileBreakPoint = 768,
        heroHomeContainer = document.querySelector('.block-hero-home__container');

    if ( heroHomeContainer === null ) {
        return;
    }

    let bgImageDesktop = document.querySelector('.block-hero-home__image'),
        bgImageMobile = document.querySelector('.block-hero-home__mobile_image'),
        bgContainer = heroHomeContainer.querySelector('.block-background-image'),
        currentSrc = '';

    function updateHomeBgImage() {
        let bgImage = null;

        // Show the correct image, depending on screen width
        if (window.innerWidth < mobileBreakPoint) {
            bgImage = bgImageMobile;
        }
        else {
            bgImage = bgImageDesktop;
        }

        // Get the src/currentSrc of correct image
        let src = typeof bgImage.currentSrc !== 'undefined' ? bgImage.currentSrc : bgImage.src;

        if (src !== currentSrc) {
            // If the image has changed (eg from a window resize event)
            currentSrc = src;  // Keep track of which image we're displaying

            // Set the new image
            bgContainer.style.backgroundImage = 'url("' + currentSrc + '")';
        }
    }

    bgImageDesktop.addEventListener('load', function () {
        updateHomeBgImage();
    });

    if (bgImageDesktop.complete) {
        updateHomeBgImage();
    }


    bgImageMobile.addEventListener('load', function () {
        updateHomeBgImage();
    });

    if (bgImageMobile.complete) {
        updateHomeBgImage();
    }

}

export function syncLinkList() {
    const dropdown = document.querySelector('.js-hero-home-link-list');

    if (dropdown) {
        const linkButton = document.querySelector('.js-hero-home-link-list-button');

        // Disable button and add event listener for navigating
        linkButton.disabled = !dropdown.value;
        linkButton.addEventListener('click', function(event) {
            window.location.href = dropdown.value;
        });

        // Enable button on dropdown value selected
        dropdown.addEventListener('change', function(event) {
            linkButton.disabled = !event.target.value;
        });
    }
}



// WEBPACK FOOTER //
// ./src/js/hero-home-page.js